import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { DxDataGridModule, DxTemplateModule } from 'devextreme-angular';
import { FleetService, DriverDto, MasterdataService } from '../../shared/generated/backend';
import { firstValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContextService } from '../../services/context.service';
import { RowDblClickEvent } from 'devextreme/ui/data_grid';
import { LoaderComponent } from '../../loader/loader.component';
import { UtilsService } from '../../services/utils.service';
import { ActivatedRoute } from '@angular/router';
import { DriverRefreshService } from './driver-refresh.service';

@Component({
  selector: 'app-driver-list',
  imports: [SharedModule, DxDataGridModule, DxTemplateModule, LoaderComponent],
  templateUrl: './driver-list.component.html',
  styleUrl: './driver-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverListComponent implements OnInit, OnDestroy {
  readonly drivers = signal(new Array<DriverDto>());
  _drivers = new Array<DriverDto>();

  isLoading = signal(false);
  private readonly destroy$ = new Subject<void>();

  private masterdataService = inject(MasterdataService);
  private fleetService = inject(FleetService);
  private contextService = inject(ContextService);
  utilService = inject(UtilsService);
  private activatedRoute = inject(ActivatedRoute);
  private driverRefreshService = inject(DriverRefreshService);

  async ngOnInit() {
    this.activatedRoute.url.pipe(takeUntil(this.destroy$)).subscribe(async _ => {
      //this.contextService.openContextView('masterdata/drivers/driver', false);
      this.isLoading.set(true);
      this._drivers = await firstValueFrom(this.fleetService.getAllDrivers());
      // if (this._drivers && this._drivers.length > 0) {
      //   const firstDriverId = this._drivers[0].employeeNumber;
      //   //this.contextService.openContextView(`masterdata/drivers/driver/${firstDriverId}`, true);
      // }
      this.showData();
      this.isLoading.set(false);
    });

    this.driverRefreshService.refresh$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.refreshDrivers();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showData() {
    this.drivers.set(this._drivers);
  }

  async refreshDrivers() {
    this.isLoading.set(true);
    this._drivers = await firstValueFrom(this.fleetService.getAllDrivers());
    this.showData();
    this.isLoading.set(false);
  }

  addDriver() {
    this.contextService.openContextView(`masterdata/drivers/driver`);
  }

  customPrioritySortValue(rowData: DriverDto) {
    const priorityOrder = {
      Undefined: 0,
      VeryHigh: 1,
      High: 2,
      Normal: 3,
      Low: 4,
      VeryLow: 5,
    };
    return priorityOrder[rowData.priority as keyof typeof priorityOrder] || 6;
  }

  customLicenseSortValue(rowData: DriverDto) {
    const licenseOrder = {
      Small: 1,
      Middle: 2,
      Big: 3,
    };
    return licenseOrder[rowData.drivingLicence as keyof typeof licenseOrder] || 4;
  }

  loadDriver(event: RowDblClickEvent) {
    this.contextService.openContextView(`masterdata/drivers/driver/${event.data.employeeNumber}`);
  }
}
